import React from 'react';

export default function CardTestimonials({ rating, text, author }) {

  const renderStars = () => {
    const filledStars = Array.from({ length: rating }, (_, index) => (
      <svg key={index} className="w-6 h-6 text-[#F9B754]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
      </svg>
    ));
    const emptyStars = Array.from({ length: 5 - rating }, (_, index) => (
      <svg key={index} className="w-4 h-4 text-gray-300 dark:text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
      </svg>
    ));
    return [...filledStars, ...emptyStars];
  };

  return (
    <div className="card transition duration-500 cursor-pointer h-[100%]">
      <button className=" mx-2 py-8 px-6 bg-white border border-gray-200 rounded-lg shadow h-[100%]">
        <div className="flex flex-col gap-4 items-start mb-4">
          <div className="flex items-center md:mb-2">
            {renderStars()}
          </div>
          <div className="flex flex-col gap-2">
            <p className="mb-2 text-left text-sm md:text-base font-pop">{text}</p> {/* Adjusted text alignment */}
            <h5 className="text-lg md:text-xl font-pop font-semibold tracking-tight text-gray-900 dark:text-black text-left">{author}</h5>
          </div>
        </div>
      </button>
    </div>
  );
}
